<template>
    <div v-if="player_name.length !== 0">
        <div class="top-bar" style="display: flex; align-items: center; margin-left: 152px;">
            <div class="type-select">
                <span style="font-size: 22px; font-weight: bold;">赛事类别：</span>
                <a-select
                    ref="select"
                    v-model="ranking_type"
                    size="large"
                    style="width: 150px;"
                    @change="onChangeType"
                    :disabled="lock"
                >
                    <a-select-option v-if="this.currentTeam === 'men'" value="Men's Singles">男子单打</a-select-option>
                    <a-select-option v-if="this.currentTeam === 'men'" value="Men's Doubles Pairs">男子双打</a-select-option>
                    <a-select-option v-if="this.currentTeam === 'men'" value="Men's Doubles Individuals">男子双打个人</a-select-option>
                    <a-select-option v-if="this.currentTeam === 'women'" value="Women's Singles">女子单打</a-select-option>
                    <a-select-option v-if="this.currentTeam === 'women'" value="Women's Doubles Pairs">女子双打</a-select-option>
                    <a-select-option v-if="this.currentTeam === 'women'" value="Women's Doubles Individuals">女子双打个人</a-select-option>
                    <a-select-option v-if="this.currentTeam === 'mixed'" value="Mixed Doubles Pairs">混合双打</a-select-option>
                    <a-select-option v-if="this.currentTeam === 'mixed'" value="Mixed Doubles Individuals">混合双打个人</a-select-option>
                </a-select>
            </div>
            <div class="time-select" style="margin-left: 69px;">
                <span style="font-size: 22px; font-weight: bold;">时间：</span>
                <a-date-picker
                    :value="startTime"
                    :locale="locale"
                    size="large"
                    @change="(date, dateString) => onChangeDate(dateString, 1)"
                    :disabled="lock"
                />
                &nbsp; <span style="font-weight: 400;">—</span> &nbsp;
                <a-date-picker
                    :value="endTime"
                    :locale="locale"
                    size="large"
                    @change="(date, dateString) => onChangeDate(dateString, 2)"
                    :disabled="lock"
                />
            </div>
            <div class="timeline">
                <Timeline :events="timeline_list" />
            </div>
            <div class="ranking-query">
                <img class="clickable"
                     src="@/assets/ranking.png" alt="积分查询"
                     @click="clickDrawer"
                     :style="{ marginLeft: '30px', width: '50px', background: this.drawer ? '#E6EBEF' : '#FFFFFF', borderRadius: '8px', }"
                />
            </div>
        </div>
        <div class="ranking-table-drawer">
            <a-drawer
                placement="bottom"
                :visible="drawer"
                :mask="false"
                :maskClosable="false"
                height="540px"
                @close="closeDrawer"
            >
                <template #title>
                    <span style="color: #00375B; font-size: 22px; font-weight: bold;">积分查询</span>
                </template>
                <div class="ranking-table">
                    <a-table
                        class="no-hover-table"
                        :columns="cur_ranking_columns"
                        :data-source="cur_rankings"
                        :pagination="{
                            pageSize: 5,
                            total: cur_rankings.length,
                            showQuickJumper: true,
                        }"
                        row-key="player_id"
                        :customRow="setRankingRowColor"
                        style="margin-right: 100px; margin-left: 100px; height: 400px;"
                    />
                </div>
                <div style="margin-right: 100px; margin-left: 100px;">
                    <a-modal
                        v-model="ranking_modal"
                        width="1200px"
                        style="text-align: center;"
                    >
                        <template #footer />
                        <span style="color: #00375B; font-size: 22px; font-weight: bold;">—————————&nbsp; {{ this.selected_cur_ranking.ranking }} &nbsp;&nbsp; {{ this.selected_cur_ranking.player_name }} &nbsp;&nbsp; {{ this.selected_cur_ranking.assoc }} —————————</span>
                        <div class="ranking-detail-table" style="display: flex; justify-content: center;">
                            <a-table
                                class="no-hover-table"
                                :columns="all_ranking_columns"
                                :data-source="all_rankings"
                                row-key="event_id"
                                :pagination="false"
                                :scroll="{ y: 500 }"
                                :customRow="setRankingDetailRowColor"
                                style="margin-top: 20px; width: 1000px; height: 600px;"
                                bordered
                            >
                                <template slot="valid" slot-scope="record">
                                    <span v-if="record.valid === 'details detailstop'" style="background: #C3F89C; padding: 5px; border-radius: 8px;">有效</span>
                                    <span v-else-if="record.valid === 'details detailspenalty'" style="background: #F18E8E; padding: 5px;border-radius: 8px;">罚分</span>
                                    <span v-else style="background: #B4B4B4; padding: 5px;border-radius: 8px;">无效</span>
                                </template>
                            </a-table>
                        </div>
                    </a-modal>
                </div>
            </a-drawer>
        </div>
        <div class="deduction-table" style="background: #F8FAFB; height: 340px; margin-left: 70px; margin-right: 70px;">
            <a-row type="flex" justify="end" style="height: 65px;">
                <a-col class="match-select" :span="5">
                    <a-row type="flex">
                        <a-col flex="20px"/>
                        <a-col flex="auto">
                            <a-row type="flex" style="height: 60px; background: #00375B;">
                                <a-col flex="50px">
                                    <a-select
                                        v-model="selected_match_id1" allowClear @change="onChangeMatch" :disabled="lock"
                                        :dropdownMatchSelectWidth='false'
                                        style="margin-top: 15px; width: 35px;"
                                    >
                                        <a-select-option
                                            v-for="match in matches"
                                            :value="match.match_id"
                                            :key="'selected_match1' + match.match_id"
                                            :disabled="setMatchDisabled(match, 1)"
                                        >
                                            {{ match.match_name }} - {{ match.location }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col flex="auto">
                                    <div style="margin-right: 50px; font-size: 20px; font-weight: bold; color: #FFFFFF;">
                                        {{ queryMatch(selected_match_id1).match_name }}
                                    </div>
                                    <div style="margin-right: 50px; font-size: 20px; font-weight: bold; color: #FFFFFF;">
                                        {{ queryMatch(selected_match_id1).location }}
                                    </div>
                                </a-col>
                            </a-row>
                        </a-col>
                        <a-col flex="20px"/>
                    </a-row>
                </a-col>
                <a-col class="match-select" :span="5">
                    <a-row type="flex">
                        <a-col flex="20px"/>
                        <a-col flex="auto">
                            <a-row type="flex" style="height: 60px; background: #00375B;">
                                <a-col flex="50px">
                                    <a-select
                                        v-model="selected_match_id2" allowClear @change="onChangeMatch" :disabled="lock"
                                        :dropdownMatchSelectWidth='false'
                                        style="margin-top: 15px; width: 35px;"
                                    >
                                        <a-select-option
                                            v-for="match in matches"
                                            :value="match.match_id"
                                            :key="'selected_match2' + match.match_id"
                                            :disabled="setMatchDisabled(match, 2)"
                                        >
                                            {{ match.match_name }} - {{ match.location }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col flex="auto">
                                    <div style="margin-right: 50px; font-size: 20px; font-weight: bold; color: #FFFFFF;">
                                        {{ queryMatch(selected_match_id2).match_name }}
                                    </div>
                                    <div style="margin-right: 50px; font-size: 20px; font-weight: bold; color: #FFFFFF;">
                                        {{ queryMatch(selected_match_id2).location }}
                                    </div>
                                </a-col>
                            </a-row>
                        </a-col>
                        <a-col flex="20px"/>
                    </a-row>
                </a-col>
                <a-col class="match-select" :span="5">
                    <a-row type="flex">
                        <a-col flex="20px"/>
                        <a-col flex="auto">
                            <a-row type="flex" style="height: 60px; background: #00375B;">
                                <a-col flex="50px">
                                    <a-select
                                        v-model="selected_match_id3" allowClear @change="onChangeMatch" :disabled="lock"
                                        :dropdownMatchSelectWidth='false'
                                        style="margin-top: 15px; width: 35px;"
                                    >
                                        <a-select-option
                                            v-for="match in matches"
                                            :value="match.match_id"
                                            :key="'selected_match3' + match.match_id"
                                            :disabled="setMatchDisabled(match, 3)"
                                        >
                                            {{ match.match_name }} - {{ match.location }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col flex="auto">
                                    <div style="margin-right: 50px; font-size: 20px; font-weight: bold; color: #FFFFFF;">
                                        {{ queryMatch(selected_match_id3).match_name }}
                                    </div>
                                    <div style="margin-right: 50px; font-size: 20px; font-weight: bold; color: #FFFFFF;">
                                        {{ queryMatch(selected_match_id3).location }}
                                    </div>
                                </a-col>
                            </a-row>
                        </a-col>
                        <a-col flex="20px"/>
                    </a-row>
                </a-col>
                <a-col :span="6">
                    <span style="font-size: 22px; font-weight: bold; margin-top: 40px;">———— 积分变化 ————</span>
                </a-col>
            </a-row>
            <a-row type="flex" style="height: 20px;">
                <a-col class="function" flex="3" style="display: flex; justify-content: flex-start;">
                    <img class="clickable" src="@/assets/upload.png" style="margin-top: 1px; margin-left: 55px; height: 20px;  width: 20px;" alt="上传"/>
                    <svg class="clickable" viewBox="0 0 25 25" height="25px" width="25px" fill="#00375B" style="margin-left: 20px;">
                        <g>
                            <path d="M20,3H4C2.89,3,2,3.89,2,5v12c0,1.1,0.89,2,2,2h4v2h8v-2h4c1.1,0,2-0.9,2-2V5C22,3.89,21.1,3,20,3z M20,17H4V5h16V17z" />
                            <rect height="1.5" width="8" x="6" y="8.25" />
                            <polygon points="16.5,9.75 18,9.75 18,8.25 16.5,8.25 16.5,7 15,7 15,11 16.5,11" />
                            <rect height="1.5" width="8" x="10" y="12.25" />
                            <polygon points="7.5,15 9,15 9,11 7.5,11 7.5,12.25 6,12.25 6,13.75 7.5,13.75" />
                        </g>
                    </svg>
                    <svg class="clickable" viewBox="0 0 25 25" height="25px" width="25px" fill="#00375B" style="margin-left: 20px;">
                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                    </svg>
                    <img class="clickable" v-if="lock" src="@/assets/lock.png" style="margin-top: 1px; margin-left: 20px; height: 20px; width: 20px;" @click="lockForDeduction" alt="锁定"/>
                    <img class="clickable" v-else src="@/assets/unlock.png" style="margin-top: 1px; margin-left: 20px; height: 20px;  width: 20px;" @click="lockForDeduction" alt="解锁"/>
                </a-col>
                <a-col class="match1-text" flex="5">
                    <a-row v-if="this.selected_match_id1 !== ''" type="flex" justify="center">
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">W</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">F</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">SF</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">Others</span>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col class="match2-text" flex="5">
                    <a-row v-if="this.selected_match_id2 !== ''" type="flex" justify="center">
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">W</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">F</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">SF</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">Others</span>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col class="match3-text" flex="5">
                    <a-row v-if="this.selected_match_id3 !== ''" type="flex" justify="center">
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">W</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">F</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">SF</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">Others</span>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col class="score-text" flex="6">
                    <a-row type="flex" justify="center">
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">三赛总计</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">赛前积分</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">失效积分</span>
                        </a-col>
                        <a-col :span="5">
                            <span style="font-size: 16px; font-weight: bold;">赛后积分</span>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row>
                <a-col class="player-select" :span="3">
                    <svg width="1740" height="5">
                        <line x1="40" y1="0" x2="1740" y2="0" stroke="#D0E7FB" stroke-width="5" />
                    </svg>
                    <img class="clickable" src="@/assets/sub.png" style="width: 25px;" @click="clearPlayer(1)" alt="清空player1"/>
                    <a-select
                        v-model="selected_player_id1" @change="onChangePlayer" size="large" :disabled="lock" :showArrow="false"
                        style="left: 20px; min-width: 90px"
                    >
                        <a-select-option
                            v-for="id in player_id"
                            :value="id"
                            :key="'selected_player_id1' + id"
                            :disabled="setPlayerDisabled(id, 1)"
                        >
                            {{ queryPlayerName(id) }}
                        </a-select-option>
                    </a-select>
                    <svg width="1740" height="5">
                        <line x1="40" y1="0" x2="1740" y2="0" stroke="#D0E7FB" stroke-width="5" />
                    </svg>
                    <img class="clickable" src="@/assets/sub.png" style="width: 25px;" @click="clearPlayer(2)" alt="清空player2"/>
                    <a-select
                        v-model="selected_player_id2" @change="onChangePlayer" size="large" :disabled="lock" :showArrow="false"
                        style="left: 20px; min-width: 90px"
                    >
                        <a-select-option
                            v-for="id in player_id"
                            :value="id"
                            :key="'selected_player_id2' + id"
                            :disabled="setPlayerDisabled(id, 2)"
                        >
                            {{ queryPlayerName(id) }}
                        </a-select-option>
                    </a-select>
                    <svg width="1740" height="5">
                        <line x1="40" y1="0" x2="1740" y2="0" stroke="#D0E7FB" stroke-width="5" />
                    </svg>
                    <img class="clickable" src="@/assets/sub.png" style="width: 25px;" @click="clearPlayer(3)" alt="清空player3"/>
                    <a-select
                        v-model="selected_player_id3" @change="onChangePlayer" size="large" :disabled="lock" :showArrow="false"
                        style="left: 20px; min-width: 90px"
                    >
                        <a-select-option
                            v-for="id in player_id"
                            :value="id"
                            :key="'selected_player_id3' + id"
                            :disabled="setPlayerDisabled(id, 3)"
                        >
                            {{ queryPlayerName(id) }}
                        </a-select-option>
                    </a-select>
                    <svg width="1740" height="5">
                        <line x1="40" y1="0" x2="1740" y2="0" stroke="#D0E7FB" stroke-width="5" />
                    </svg>
                    <div style="background: #F3F2F2; margin-left: 100px; width: 90px; height: 42px;">
                        <img class="clickable" src="@/assets/add.png" style="margin-top:8px; width: 25px;" alt="添加球员"/>
                    </div>
                </a-col>
                <a-col class="match-result" :span="15">
                    <svg width="1110" height="200">
                        <line x1="0" y1="20" x2="0" y2="185" stroke="#00375B" stroke-width="5" />
                        <g v-if="lock && selected_match_id1 !== ''">
                            <g v-for="(offset, place_index) in [0, 77.5, 155, 232.5]" :key="place_index">
                                <circle
                                    v-for="(player_id, player_index) in selected_player_id_list"
                                    :key="'match1-player' + player_index + '-' + place_index + '-circle'"
                                    :cx="68 + offset"
                                    :cy="40 + player_index * 61"
                                    :r="player_id !== '' ? 7 : 0"
                                    :fill="setCircleColor(0, player_index, place_index)"
                                />
                                <text
                                    v-for="(_, player_index) in selected_player_id_list"
                                    :key="'match1-player' + player_index + '-' + place_index + '-score'"
                                    :x="68 + offset"
                                    :y="65 + player_index * 61"
                                    text-anchor="middle"
                                    font-size="15px"
                                    font-weight="900"
                                    fill="#00375B"
                                >
                                    {{ setResultScore(0, player_index, place_index) }}
                                </text>
                            </g>
                        </g>
                        <g v-if="lock && selected_match_id2 !== ''">
                            <g v-for="(offset, place_index) in [0, 77.5, 155, 232.5]" :key="place_index">
                                <circle
                                    v-for="(player_id, player_index) in selected_player_id_list"
                                    :key="'match2-player' + player_index + place_index"
                                    :cx="439 + offset"
                                    :cy="40 + player_index * 61"
                                    :r="player_id !== '' ? 7 : 0"
                                    :fill="setCircleColor(1, player_index, place_index)"
                                />
                                <text
                                    v-for="(_, player_index) in selected_player_id_list"
                                    :key="'match2-player' + player_index + '-' + place_index + '-score'"
                                    :x="439 + offset"
                                    :y="65 + player_index * 61"
                                    text-anchor="middle"
                                    font-size="15px"
                                    font-weight="900"
                                    fill="#00375B"
                                >
                                    {{ setResultScore(1, player_index, place_index) }}
                                </text>
                            </g>
                        </g>
                        <g v-if="lock && selected_match_id3 !== ''">
                            <g v-for="(offset, place_index) in [0, 77.5, 155, 232.5]" :key="place_index">
                                <circle
                                    v-for="(player_id, player_index) in selected_player_id_list"
                                    :key="'match3-player' + player_index + place_index"
                                    :cx="810 + offset"
                                    :cy="40 + player_index * 61"
                                    :r="player_id !== '' ? 7 : 0"
                                    :fill="setCircleColor(2, player_index, place_index)"
                                />
                                <text
                                    v-for="(_, player_index) in selected_player_id_list"
                                    :key="'match3-player' + player_index + '-' + place_index + '-score'"
                                    :x="810 + offset"
                                    :y="65 + player_index * 61"
                                    text-anchor="middle"
                                    font-size="15px"
                                    font-weight="900"
                                    fill="#00375B"
                                >
                                    {{ setResultScore(2, player_index, place_index) }}
                                </text>
                            </g>
                        </g>
                        <g v-if="lock">
                            <g v-for="collected_result in collected_result_list " :key="'collected_result' + collected_result['result_id']">
                                <circle
                                    v-for="(coordinate, index) in collected_result['coordinates']"
                                    :key="'collected_result' + collected_result['result_id'] + '-circle' + index"
                                    :cx="coordinate[0]"
                                    :cy="coordinate[1]"
                                    r="7"
                                    fill="#00375B"

                                />
                                <line
                                    v-for="(coordinate, index) in collected_result['coordinates'].slice(0, -1)"
                                    :key="'collected_result' + collected_result['result_id'] + '-line' + index"
                                    :x1="coordinate[0]"
                                    :y1="coordinate[1]"
                                    :x2="collected_result['coordinates'][index + 1][0]"
                                    :y2="collected_result['coordinates'][index + 1][1]"
                                    stroke="#00375B"
                                    stroke-width="1"
                                    stroke-dasharray="5 5"
                                />
                            </g>
                            <line
                                v-for="(coordinate, index) in coordinates.slice(0, -1)"
                                :key="'cur_result-line' + index"
                                :x1="coordinate[0]"
                                :y1="coordinate[1]"
                                :x2="coordinates[index + 1][0]"
                                :y2="coordinates[index + 1][1]"
                                stroke="#00375B"
                                stroke-width="1"
                                stroke-dasharray="5 5"
                            />
                        </g>
                    </svg>
                </a-col>
                <a-col :span="6">
                    <svg width="440" height="200">
                        <line x1="0" y1="20" x2="0" y2="185" stroke="#00375B" stroke-width="5" />
                        <g v-for="(offset, content_index) in [0, 93, 186, 279]" :key="content_index">
                            <text
                                v-for="(_, player_index) in selected_player_id_list"
                                :key="'player' + player_index + '-' + content_index"
                                :x="79 + offset"
                                :y="49 + player_index * 61"
                                text-anchor="middle"
                                font-size="20px"
                                font-weight="900"
                                fill="#00375B"
                            >
                                {{ setResultScoreChange(player_index, content_index) }}
                            </text>
                        </g>
                        <g v-for="(player_id, player_index) in selected_player_id_list" :key="player_index + 'arrow'">
                            <g v-if="player_id !== '' && selected_result_id !== -1">
                                <image
                                    v-if="setResultScoreArrow(player_index) === 1"
                                    href="@/assets/up_green.png"
                                    x="390"
                                    :y="25 + player_index * 61"
                                    width="30"
                                    height="30"
                                />
                                <image
                                    v-else-if="setResultScoreArrow(player_index) === -1"
                                    href="@/assets/down_red.png"
                                    x="390"
                                    :y="25 + player_index * 61"
                                    width="30"
                                    height="30"
                                />
                                <text
                                    v-else
                                    :x="405"
                                    :y="49 + player_index * 61"
                                    text-anchor="middle"
                                    font-size="20px"
                                    font-weight="900"
                                    fill="#00375B"
                                >
                                    -
                                </text>
                            </g>
                        </g>
                    </svg>
                </a-col>
            </a-row>
        </div>
        <a-row style="margin-top: 20px">
            <a-col :span="10">
                <div class="condition-table"
                    style="height: 500px; margin-left: 70px; margin-right: 20px;"
                >
                    <span style="font-size: 22px; font-weight: bold;">———— 筛选条件 ————</span>
                        <div style="background: #F8FAFB; padding: 16px; height: 480px;">
                        <a-row type="flex" justify="start">
                            <a-col flex="60px">
                                <svg class="clickable" height="25px" viewBox="0 0 25 25" width="25px" fill="#00375B" style="margin-top: 10px;">
                                    <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
                                </svg>
                            </a-col>
                            <a-col flex="546px">
                                <a-input-search
                                    v-model="new_condition"
                                    placeholder="请输入筛选条件"
                                    size="large"
                                    :loading="loading_conditions"
                                    @search="addCondition"
                                >
                                    <template #enterButton>
                                        <a-button>
                                            <img class="clickable" src="@/assets/message.png" style="width: 16px;" alt="添加新条件"/>
                                        </a-button>
                                    </template>
                                </a-input-search>
                            </a-col>
                            <a-col flex="55px">
                                <img class="clickable" src="@/assets/filter.png" style="margin-top: 8px; width: 25px;" @click="getResults"  alt="进行结果筛选"/>
                            </a-col>
                        </a-row>
                        <a-table
                            v-if="conditions.length > 0"
                            :columns="condition_columns"
                            :dataSource="conditions"
                            row-key="condition_id"
                            :showHeader="false"
                            :pagination="false"
                            :scroll="{ y: 370 }"
                            :row-selection="{ selectedRowKeys: selected_condition_id_list, onChange: changeConditions }"
                            style="margin-top: 15px;"
                        >
                            <template slot="condition" slot-scope="record">
                                <div v-if="record.type === 'score requirement'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        积分
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'GE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'EQ'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        =
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.requirement }}
                                    </span>
                                </div>
                                <div v-else-if="record.type === 'score trend'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        积分
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        增加
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'EQ'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        不变
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        降低
                                    </span>
                                </div>
                                <div v-else-if="record.type === 'score comparison'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        积分
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'GE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'EQ'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        =
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.compared_player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        积分
                                    </span>
                                </div>
                                <div v-else-if="record.type === 'place requirement'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.match_name }}
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'GE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'EQ'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        =
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;
                                    </span>
                                    <span
                                        v-if="record.place === 'First'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        冠军
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Second'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        亚军
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Third'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        季军
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Fourth'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        4强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 8'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        8强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 16'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        16强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 24'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        24强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 32'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        32强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 48'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        48强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 64'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        64强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 128'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        128强
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifier'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        正赛名额
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifying Round 3'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        第三轮资格赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifying Round 2'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        第二轮资格赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifying Round 1'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        第一轮资格赛
                                    </span>
                                </div>
                                <div v-else-if="record.type === 'medal requirement'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        v-if="record.medal_type === 'Gold'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        金牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Silver'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        银牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Bronze'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        铜牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Any'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        奖牌数
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'GE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'EQ'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        =
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.requirement }}
                                    </span>
                                </div>
                                <div v-else-if="record.type === 'medal comparison'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        v-if="record.medal_type === 'Gold'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        金牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Silver'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        银牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Bronze'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        铜牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Any'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        奖牌数
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'GE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'EQ'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        =
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LE'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;=
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.compared_player_name }}
                                    </span>
                                    <span
                                        v-if="record.medal_type === 'Gold'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        金牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Silver'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        银牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Bronze'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        铜牌数
                                    </span>
                                    <span
                                        v-else-if="record.medal_type === 'Any'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        奖牌数
                                    </span>
                                </div>
                                <div v-else-if="record.type === 'general outcome'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.match_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        名次
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        >
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        &lt;
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.compared_player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        名次
                                    </span>
                                </div>
                                <div v-else-if="record.type === 'specific outcome'">
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.player_name }}
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.match_name }}
                                    </span>
                                    <span
                                        v-if="record.place === 'First'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        决赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Second'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        决赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Third'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        半决赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Fourth'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        半决赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 8'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        8强晋级赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 16'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        16强晋级赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 24'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        24强晋级赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 32'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        32强晋级赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 48'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        48强晋级赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 64'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        64强晋级赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Round of 128'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        128强晋级赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifier'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        正赛名额争夺战
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifying Round 3'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        第三轮资格赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifying Round 2'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        第二轮资格赛
                                    </span>
                                    <span
                                        v-else-if="record.place === 'Qualifying Round 1'"
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        第一轮资格赛
                                    </span>
                                    <span
                                        v-if="record.operator === 'GT'"
                                        style="margin-left: 5px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        胜
                                    </span>
                                    <span
                                        v-else-if="record.operator === 'LT'"
                                        style="margin-left: 5px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        败
                                    </span>
                                    <span
                                        style="margin-left: 5px;
                                            background: #F3F2F2; border-radius: 8px; padding: 10px;
                                            text-align: center; font-size: 18px; font-weight: bold; color: #00375B;"
                                    >
                                        {{ record.compared_player_name }}
                                    </span>
                                </div>
                            </template>
                            <template slot="delete" slot-scope="record">
                                <a-popconfirm
                                    title="是否删除该筛选条件"
                                    placement="right"
                                    ok-text="确定"
                                    cancel-text="取消"
                                    @confirm="deleteCondition(record.condition_id)"
                                >
                                    <svg class="clickable" viewBox="0 0 25 25" height="25px" width="25px" fill="#00375B">
                                        <path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z" />
                                    </svg>
                                </a-popconfirm>
                            </template>
                        </a-table>
                        <div v-else style="margin-top: 15px; height: 220px;">
                            <a-empty style="margin-top: 85px;">
                                <template #description>
                                    <span>暂无筛选条件</span>
                                </template>
                            </a-empty>
                        </div>
                    </div>
                </div>
            </a-col>
            <a-col :span="14">
                <div class="result-table"
                    style="height: 500px; margin-left: 20px; margin-right: 70px;"
                >
                    <span style="font-size: 22px; font-weight: bold;">———— 预期结果 ————</span>
                    <div style="background: #F8FAFB; padding: 16px; height: 480px;">
                        <a-icon
                            v-if="loading_results"
                            type="loading"
                            :style="{ fontSize: '80px', color: '#00375B', marginTop: '160px', }"
                        />
                        <div v-else-if="results.length > 0">
                            <div>
                                <a-row style="height: 40px; position: relative;" type="flex">
                                    <a-col flex="5px"/>
                                    <a-col v-if="selected_match_id1 !== ''" flex="210px">
                                        <div style="background: #00375B; padding: 5px 30px; text-align: center; font-size: 14px; font-weight: bold; color: #F8FAFB;">
                                            {{ queryMatch(selected_match_id1).match_name }}
                                            <br>
                                            {{ queryMatch(selected_match_id1).location }}
                                        </div>
                                    </a-col>
                                    <a-col flex="10px"/>
                                    <a-col v-if="selected_match_id2 !== ''" flex="200px">
                                        <div style="background: #00375B; padding: 5px 30px; text-align: center; font-size: 14px; font-weight: bold; color: #F8FAFB;">
                                            {{ queryMatch(selected_match_id2).match_name }}
                                            <br>
                                            {{ queryMatch(selected_match_id2).location }}
                                        </div>
                                    </a-col>
                                    <a-col flex="10px"/>
                                    <a-col v-if="selected_match_id3 !== ''" flex="210px">
                                        <div style="background: #00375B; padding: 5px 30px; text-align: center; font-size: 14px; font-weight: bold; color: #F8FAFB;">
                                            {{ queryMatch(selected_match_id3).match_name }}
                                            <br>
                                            {{ queryMatch(selected_match_id3).location }}
                                        </div>
                                    </a-col>
                                    <a-col flex="5px"/>
                                    <a-col flex="60px" style="margin-top: 15px; position: absolute; left: 664px;">
                                        <img src="@/assets/gold.png" style="width: 30px;" alt="金牌"/>
                                    </a-col>
                                    <a-col flex="60px" style="margin-top: 15px; position: absolute; left: 724px;">
                                        <img src="@/assets/silver.png" style="width: 30px;" alt="银牌"/>
                                    </a-col>
                                    <a-col flex="60px" style="margin-top: 15px; position: absolute; left: 784px;">
                                        <img src="@/assets/bronze.png" style="width: 30px;" alt="铜牌"/>
                                    </a-col>
                                    <a-col style="margin-top: 15px; position: absolute; right: 100px;">
                                        <img class="clickable" src="@/assets/more.png" @click="getMoreResults(10)" style="width: 30px;" alt="加载更多"/>
                                    </a-col>
                                    <a-col style="margin-top: 15px; position: absolute; right: 40px;">
                                        <img class="clickable" src="@/assets/download.png" style="width: 30px;" alt="下载"/>
                                    </a-col>
                                </a-row>
                            </div>
                            <a-table
                                class="no-hover-table"
                                :columns="resultColumns"
                                :dataSource="results"
                                row-key="result_id"
                                :customRow="setResultRowColor"
                                :showHeader="false"
                                :pagination="false"
                                :scroll="{ y: 380 }"
                                style="margin-top: 30px;"
                            >
                                <template slot="operation" slot-scope="text, record, index">
                                    <img class="clickable"
                                        v-if="isCollected(record.result_id)" src="@/assets/collected.png"  @click="collectResult(record.result_id)"
                                        style="width: 25px;" alt="已收藏该结果"
                                    />
                                    <img class="clickable"
                                        v-else src="@/assets/collect.png"  @click="collectResult(record.result_id)"
                                        style="width: 25px;" alt="收藏该结果"
                                    />
                                    <img class="clickable"
                                        src="@/assets/detail.png" @click="selectResult(record.result_id)" alt="取消选择该行结果"
                                        :style="{ width: '25px', background: selected_result_id === record.result_id ? '#7796B1' : index % 2 === 0 ? '#D5E3EF' : '#F8FAFB', marginLeft: '15px', marginRight: '15px', }"
                                    />
                                    <a-popconfirm
                                        title="是否删除该预期结果"
                                        placement="left"
                                        ok-text="确定"
                                        cancel-text="取消"
                                        @confirm="deleteResult(record.result_id)"
                                    >
                                        <img class="clickable" src="@/assets/delete.png" style="width: 25px;" alt="删除该行结果"/>
                                    </a-popconfirm>
                                </template>
                            </a-table>
                        </div>
                        <div v-else style="margin-top: 15px; height: 220px;">
                            <a-empty style="margin-top: 125px;">
                                <template #description>
                                    <span>暂无筛选结果</span>
                                </template>
                            </a-empty>
                        </div>
                    </div>

                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import {
    getTeamPlayersWithoutSelectCheck,
    getPlayerCurRankingByType,
    getPlayerAllRankingByWTTId,
    getMatchListByDate,
    setDeductionPlayer,
    setDeductionMatchId,
    addFilterCondition,
    deleteFilterCondition,
    deleteAllFilterCondition,
    getPlayerHeadshotById,
    getFilterResults,
    getNextGroupOfFilterResults,
} from '../api/index';
import Timeline from '../components/ranking/TimeLine.vue';

export default {
    name: 'Rankings',
    components: {
        Timeline,
    },
    data() {
        return {
            locale,
            currentTeam: '',
            // top-bar
            ranking_type: '',
            startTime: '2025-04-22', // Debug 静态数据 -> null
            endTime: '2025-05-27',
            matches: [],
            timeline_list: [],
            // ranking-query
            drawer: false,
            cur_ranking_columns: [
                {
                    title: '排名',
                    dataIndex: 'ranking',
                    key: 'ranking',
                    width: 100,
                    align: 'center',
                },
                {
                    title: '球员姓名',
                    dataIndex: 'player_name',
                    key: 'player_name',
                    width: 200,
                    align: 'center',
                },
                {
                    title: '国籍',
                    dataIndex: 'assoc',
                    key: 'assoc',
                    width: 200,
                    align: 'center',
                },
                {
                    title: '积分',
                    dataIndex: 'points',
                    key: 'points',
                    width: 200,
                    align: 'center',
                },
            ],
            all_ranking_columns: [
                {
                    title: '',
                    key: 'valid',
                    width: 100,
                    align: 'center',
                    scopedSlots: { customRender: 'valid' }
                },
                {
                    title: '赛事名称',
                    dataIndex: 'event_name',
                    key: 'event_name',
                    width: 400,
                    align: 'center',
                },
                {
                    title: '失效日期',
                    dataIndex: 'date',
                    key: 'date',
                    width: 200,
                    align: 'center',
                },
                {
                    title: '名次',
                    dataIndex: 'position',
                    key: 'position',
                    width: 100,
                    align: 'center',
                },
                {
                    title: '积分',
                    dataIndex: 'point',
                    key: 'point',
                    width: 100,
                    align: 'center',
                },
            ],
            cur_rankings: [],
            selected_cur_ranking: {},
            all_rankings: [],
            ranking_modal: false,
            // deduction-part
            lock: false,
            player_id: [],
            player_name: [],
            selected_player_id1: '',
            selected_player_id2: '',
            selected_player_id3: '',
            selected_player_id_list: ['', '', ''],
            selected_player_name_list: ['', '', ''],
            selected_match_id1: '',
            selected_match_id2: '',
            selected_match_id3: '',
            selected_match_id_list: ['', '', ''],
            selected_result_id: -1,
            coordinates: [],
            // condition-part
            new_condition: '',
            loading_conditions: false,
            condition_columns: [
                {
                    title: '条件',
                    key: 'condition',
                    width: 700,
                    scopedSlots: { customRender: 'condition' }
                },
                {
                    title: '删除',
                    key: 'delete',
                    width: 55,
                    fixed: 'right',
                    scopedSlots: { customRender: 'delete' }
                },
            ],
            conditions: [],
            selected_condition_id_list: [],
            // result-part
            loading_results: false,
            selected_player_headshot_list: [],
            results: [],
            current_result_cnt: 0,
            collected_result_list: [],
        }
    },
    created() {
        const userInfo = this.$store.state.userInfo
        if(!userInfo) {
            this.$router.push('/login')
        }
    },
    mounted() {
        this.currentTeam = this.$store.state.currentTeam;
        this.getPlayerOptions();
    },
    computed: {
        resultColumns() {
            const fixedColumns = [
                {
                    key: 'gold_medal',
                    dataIndex: 'medal[0]',
                    width: 60,
                    align: 'center',
                },
                {
                    key: 'silver_medal',
                    dataIndex: 'medal[1]',
                    width: 60,
                    align: 'center',
                },
                {
                    key: 'bronze_medal',
                    dataIndex: 'medal[2]',
                    width: 60,
                    align: 'center',
                },
                {
                    key: 'operation',
                    width: 150,
                    align: 'center',
                    scopedSlots: { customRender: 'operation' },
                },
            ]
            const blankColumns = {
                title: "",
                align: 'center',
                customHeaderCell: () => ({
                    style: { backgroundColor: '#F8FAFB' }
                })
            }
            const selected_match_id_list = this.selected_match_id_list.filter(item => item !== '')
            if (selected_match_id_list.length === 0) {
                return [blankColumns, blankColumns, blankColumns, ...fixedColumns]
            }
            const matchColumns = selected_match_id_list.map((match_id) => ({
                dataIndex: 'match' + match_id,
                key: match_id,
                align: 'center',
                customRender: (text, record) => {
                    let content = []
                    this.selected_player_name_list.forEach((player_name, player_index) => {
                        if (player_name !== '') {
                            content.push(
                                <tr key={ match_id + player_name }>
                                    <td style={{ fontSize: '16px' }}>
                                        { player_name }
                                    </td>
                                    <td style={{ fontSize: '16px' }}>
                                        + { record.score_result[match_id][player_index] }
                                    </td>
                                </tr>
                            )
                        }
                    })
                    return (
                        <table>
                            <tbody>
                                { content }
                            </tbody>
                        </table>
                    )
                }
            }))
            if (selected_match_id_list.length === 1) {
                return [...matchColumns, blankColumns, blankColumns, ...fixedColumns]
            }
            else if (selected_match_id_list.length === 2) {
                return [...matchColumns, blankColumns, ...fixedColumns]
            }
            else {
                return [...matchColumns, ...fixedColumns]
            }
        },
    },
    watch: {
        '$store.state.currentTeam'() {
            this.ranking_type = ''
            this.drawer = false
            this.ranking_modal = false
            // deduction-part
            this.lock = false
            this.selected_player_id1 = ''
            this.selected_player_id2 = ''
            this.selected_player_id3 = ''
            this.selected_player_id_list = ['', '', '']
            this.selected_player_name_list = ['', '', '']
            this.selected_match_id1 = ''
            this.selected_match_id2 = ''
            this.selected_match_id3 = ''
            this.selected_match_id_list = ['', '', '']
            this.selected_result_id = -1
            this.coordinates = []
            // condition-part
            this.new_condition = ''
            this.loading_conditions = false
            this.conditions = []
            deleteAllFilterCondition()
            this.selected_condition_id_list = []
            // result-part
            this.loading_results = false
            this.selected_player_headshot_list = []
            this.results = []
            this.current_result_cnt = 0
            this.collected_result_list = []
            this.getOptions()
        }
    },
    methods: {
        // top-bar
        onChangeType() {
            getPlayerCurRankingByType(this.ranking_type).then((response) => {
                if (response.status === 200) {
                    if (response.data.success) {
                        this.cur_rankings = response.data.data
                        if (this.startTime !== '' && this.endTime !== '' && this.ranking_type !== '') {
                            this.queryMatchList()
                        }
                    }
                }
            })
        },
        onChangeDate(dateString, index) {
            if (index === 1) {
                this.startTime = dateString
            }
            else {
                this.endTime = dateString
            }
            if (this.startTime !== '' && this.endTime !== '' && this.ranking_type !== '') {
                this.queryMatchList()
            }
        },
        queryMatchList() {
            this.matches = []
            getMatchListByDate(this.startTime, this.endTime, this.ranking_type).then((response) => {
                if (response.status === 200) {
                    if (response.data.success) {
                        this.matches = response.data.data
                        this.setTimeLine()
                    }
                }
            })
        },
        setTimeLine() {
            this.timeline_list = []
            this.matches.forEach(match => {
                this.timeline_list.push({
                    id: match.match_id,
                    name: match.match_name,
                    time: String(match.start_date[0]) + "/" + String(match.start_date[1]).padStart(2, '0') + "/" + String(match.start_date[2]).padStart(2, '0')
                        + "-" + String(match.end_date[0]) + "/" + String(match.end_date[1]).padStart(2, '0') + "/" + String(match.end_date[2]).padStart(2, '0'),
                    size: parseInt(match.ranking[0].points) / 120 + 5,
                    color: match.match_id === this.selected_match_id1 ? '#00375B'
                         : match.match_id === this.selected_match_id2 ? '#00375B'
                         : match.match_id === this.selected_match_id3 ? '#00375B' :'#D9D9D9',
                })
            })
        },
        clickDrawer() { this.drawer = !this.drawer },
        closeDrawer() { this.drawer = false },
        setRankingRowColor(record, index) {
            return {
                style: {
                    backgroundColor: index % 2 === 0 ? '#D5E3EF' : '#F8FAFB',
                    color: '#00375B',
                    fontSize: '18px',
                    fontWeight: 'bold',
                },
                on: {
                    click: () => {
                        this.selected_cur_ranking = record
                        getPlayerAllRankingByWTTId(this.ranking_type, this.selected_cur_ranking.player_id).then((response) => {
                            if (response.status === 200) {
                                if (response.data.success) {
                                    this.all_rankings = response.data.data[0]
                                    this.ranking_modal = true
                                }
                            }
                        })
                    },
                },
            }
        },
        setRankingDetailRowColor(record, index) {
            return {
                style: {
                    backgroundColor: index % 2 === 0 ? '#D5E3EF' : '#F8FAFB',
                    color: '#00375B',
                    fontSize: '18px',
                    fontWeight: 'bold',
                },
            }
        },
        // deduction-part
      getOptions() {
        this.$store.commit('setLoading', true)
        this.currentTeam = this.$store.state.currentTeam
        // 增加错误捕获，避免loading一直处于加载状态
        this.getPlayerOptions().then(() => {
          this.$store.commit('setLoading', false)
        }).catch((error) => {
          console.error('获取球员列表失败：', error)
          this.$store.commit('setLoading', false)
        })
      },
      async getPlayerOptions() {
        try {
          // 并行请求两个队伍的球员数据（效率更高）
          const [foreignMenRes, menRes] = await Promise.all([
            getTeamPlayersWithoutSelectCheck('foreign_men'),
            getTeamPlayersWithoutSelectCheck('men')
          ])

          // 合并两个队伍的球员数据（先初始化空数组避免重复）
          let allPlayers = []

          // 处理foreign_men队伍数据
          if (foreignMenRes.status === 200 && foreignMenRes.data.success) {
            allPlayers = [...allPlayers, ...foreignMenRes.data.players]
          }

          // 处理men队伍数据
          if (menRes.status === 200 && menRes.data.success) {
            allPlayers = [...allPlayers, ...menRes.data.players]
          }

          // 【可选】去重处理（如果两个队伍可能有重复球员，根据player_id去重）
          const uniquePlayers = Array.from(
              new Map(allPlayers.map(player => [player.player_id, player])).values()
          )

          // 清空原有数据，重新赋值（保持响应式）
          this.player_name = []
          this.player_id = []

          // 合并后的数据赋值到数组中
          uniquePlayers.forEach((player, index) => {
            // 两种方式都能保持响应式，选一种即可
            // 方式1：$set（兼容所有场景）
            this.$set(this.player_name, index, player.player_name)
            this.$set(this.player_id, index, player.player_id)

            // 方式2：push（更简洁，数组已初始化时推荐）
            // this.player_name.push(player.player_name)
            // this.player_id.push(player.player_id)
          })

        } catch (error) {
          console.error('请求球员数据异常：', error)
          throw error // 抛出错误让外层catch捕获
        }
      },
        onChangePlayer() {
            this.selected_player_id_list = []
            if (this.selected_player_id1 === undefined) {
                this.selected_player_id1 = ''
            }
            this.selected_player_id_list.push(this.selected_player_id1)
            if (this.selected_player_id2 === undefined) {
                this.selected_player_id2 = ''
            }
            this.selected_player_id_list.push(this.selected_player_id2)
            if (this.selected_player_id3 === undefined) {
                this.selected_player_id3 = ''
            }
            this.selected_player_id_list.push(this.selected_player_id3)
            this.selected_player_name_list = []
            this.selected_player_id_list.forEach(player_id => {
                if (player_id === '') {
                    this.selected_player_name_list.push('')
                }
                else {
                    this.selected_player_name_list.push(this.queryPlayerName(player_id))
                }
            })
            // result-table
            this.selected_result_id = -1
            this.coordinates = []
            // condition-part
            this.new_condition = ''
            this.loading_conditions = false
            this.conditions = []
            deleteAllFilterCondition()
            this.selected_condition_id_list = []
            // result-part
            this.loading_results = false
            this.selected_player_headshot_list = []
            this.results = []
            this.current_result_cnt = 0
            this.collected_result_list = []
        },
        clearPlayer(player_index) {
            if (this.lock) {
                this.$message.error('请先解锁')
                return
            }
            if (player_index === 1) {
                this.selected_player_id1 = ''
            }
            else if (player_index === 2) {
                this.selected_player_id2 = ''
            }
            else if (player_index === 3) {
                this.selected_player_id3 = ''
            }
            this.onChangePlayer()
        },
        setPlayerDisabled(player_id, player_selector_index) {
            if (player_selector_index === 1 && player_id === this.selected_player_id1) return false
            if (player_selector_index === 2 && player_id === this.selected_player_id2) return false
            if (player_selector_index === 3 && player_id === this.selected_player_id3) return false
            return [this.selected_player_id1, this.selected_player_id2, this.selected_player_id3].filter(Boolean).includes(player_id)
        },
        queryPlayerId(player_name) {
            for (let i = 0; i < this.player_name.length; ++i) {
                if (player_name === this.player_name[i]) {
                    return this.player_id[i]
                }
            }
            return "";
        },
        queryPlayerName(player_id) {
            for (let i = 0; i < this.player_id.length; ++i) {
                if (player_id === this.player_id[i]) {
                    return this.player_name[i]
                }
            }
            return "";
        },
        onChangeMatch() {
            this.selected_match_id_list = []
            if (this.selected_match_id1 === undefined) {
                this.selected_match_id1 = ''
            }
            this.selected_match_id_list.push(this.selected_match_id1)
            if (this.selected_match_id2 === undefined) {
                this.selected_match_id2 = ''
            }
            this.selected_match_id_list.push(this.selected_match_id2)
            if (this.selected_match_id3 === undefined) {
                this.selected_match_id3 = ''
            }
            this.selected_match_id_list.push(this.selected_match_id3)
            this.setTimeLine()
            // result-table
            this.selected_result_id = -1
            this.coordinates = []
            // condition-part
            this.new_condition = ''
            this.loading_conditions = false
            this.conditions = []
            deleteAllFilterCondition()
            this.selected_condition_id_list = []
            // result-part
            this.loading_results = false
            this.selected_player_headshot_list = []
            this.results = []
            this.current_result_cnt = 0
            this.collected_result_list = []
        },
        setMatchDisabled(match, match_selector_index) {
            if (match_selector_index === 1 && match.match_id === this.selected_match_id1) return false
            if (match_selector_index === 2 && match.match_id === this.selected_match_id2) return false
            if (match_selector_index === 3 && match.match_id === this.selected_match_id3) return false
            return [this.selected_match_id1, this.selected_match_id2, this.selected_match_id3].filter(Boolean).includes(match.match_id)
        },
        queryMatch(match_id) {
            for (let i = 0; i < this.matches.length; ++i) {
                if (match_id === this.matches[i].match_id) return this.matches[i];
            }
            return {};
        },
        async lockForDeduction() {
            this.lock = !this.lock
            if (this.lock) {
                const selected_player_id_list = this.selected_player_id_list.filter(item => item !== '')
                this.selected_player_id_list = [...selected_player_id_list, '', '', ''].slice(0, 3)
                this.selected_player_id1 = this.selected_player_id_list[0]
                this.selected_player_id2 = this.selected_player_id_list[1]
                this.selected_player_id3 = this.selected_player_id_list[2]
                const selected_player_name_list = this.selected_player_name_list.filter(item => item !== '')
                this.selected_player_name_list = [...selected_player_name_list, '', '', ''].slice(0, 3)
                const selected_match_id_list = this.selected_match_id_list.filter(item => item !== '')
                this.selected_match_id_list = [...selected_match_id_list, '', '', ''].slice(0, 3)
                this.selected_match_id1 = this.selected_match_id_list[0]
                this.selected_match_id2 = this.selected_match_id_list[1]
                this.selected_match_id3 = this.selected_match_id_list[2]
                await setDeductionPlayer(selected_player_id_list, selected_player_name_list)
                await setDeductionMatchId(selected_match_id_list)
                await this.getPlayerHeadshot()
                // Debug set conditions and results
                // this.conditions = []
                // this.results = []
                // console.log(this.cur_rankings)
                // console.log(this.all_rankings)
            }
        },
        queryResult(result_id) {
            for (let i = 0; i < this.results.length; ++i) {
                if (result_id === this.results[i].result_id) return this.results[i];
            }
            return {};
        },
        calculateCoordinates(result_id) {
            let coordinates = []
            this.selected_match_id_list.forEach((_, match_index) => {
                if (this.selected_match_id_list[match_index] !== '') {
                    this.selected_player_id_list.forEach((_, player_index) => {
                        if (this.selected_player_id_list[player_index] !== '') {
                            for (let place_index = 0; place_index < 4; ++place_index) {
                                let place = this.queryResult(result_id).place_result[this.selected_match_id_list[match_index]][player_index]
                                if (place === 'First') {
                                    if (place_index === 0) {
                                        coordinates.push([68 + match_index * 371 + place_index * 77.5, 40 + player_index * 61])
                                    }
                                }
                                else if (place === 'Second') {
                                    if (place_index === 1) {
                                        coordinates.push([68 + match_index * 371 + place_index * 77.5, 40 + player_index * 61])
                                    }
                                }
                                else if (place === 'Third' || place === 'Fourth') {
                                    if (place_index === 2) {
                                        coordinates.push([68 + match_index * 371 + place_index * 77.5, 40 + player_index * 61])
                                    }
                                }
                                else if (place_index === 3) {
                                    coordinates.push([68 + match_index * 371 + place_index * 77.5, 40 + player_index * 61])
                                }
                            }
                        }
                    })
                }
            })
            coordinates.sort((a, b) => a[0] - b[0])
            return coordinates
        },
        setCircleColor(match_index, player_index, place_index) {
            if (this.selected_result_id === -1) {
                return '#D9D9D9'
            }
            let place = this.queryResult(this.selected_result_id).place_result[this.selected_match_id_list[match_index]][player_index]
            if (place === 'First') {
                if (place_index === 0) {
                    return '#00375B'
                }
            }
            else if (place === 'Second') {
                if (place_index === 1) {
                    return '#00375B'
                }
            }
            else if (place === 'Third' || place === 'Fourth') {
                if (place_index === 2) {
                    return '#00375B'
                }
            }
            else if (place_index === 3) {
                return '#00375B'
            }
            return '#D9D9D9'
        },
        setResultScore(match_index, player_index, place_index) {
            if (this.selected_result_id === -1) {
                return ''
            }
            if(this.selected_match_id_list[match_index] === '') {
                return ''
            }
            if (this.selected_player_id_list[player_index] === '') {
                return ''
            }
            let result = this.queryResult(this.selected_result_id)
            let place = result.place_result[this.selected_match_id_list[match_index]][player_index]
            if (place === 'First') {
                if (place_index === 0) {
                    return result.score_result[this.selected_match_id_list[match_index]][player_index]
                }
            }
            else if (place === 'Second') {
                if (place_index === 1) {
                    return result.score_result[this.selected_match_id_list[match_index]][player_index]
                }
            }
            else if (place === 'Third' || place === 'Fourth') {
                if (place_index === 2) {
                    return result.score_result[this.selected_match_id_list[match_index]][player_index]
                }
            }
            else if (place_index === 3) {
                return result.score_result[this.selected_match_id_list[match_index]][player_index]
            }
            return ''
        },
        setResultScoreChange(player_index, content_index) {
            if (this.selected_result_id === -1) {
                return ''
            }
            if (this.selected_player_id_list[player_index] === '') {
                return ''
            }
            let result = this.queryResult(this.selected_result_id)
            if (content_index === 0) {
                let score = 0
                this.selected_match_id_list.forEach(match_id => {
                    if (match_id !== '') {
                        score += result.score_result[match_id][player_index]
                    }
                })
                return "+" + String(score)
            }
            else if (content_index === 1) {
                return result.pre_score_list[player_index]
            }
            else if (content_index === 2) {
                let score = 0
                this.selected_match_id_list.forEach(match_id => {
                    if (match_id !== '') {
                        score += result.score_result[match_id][player_index]
                    }
                })
                return result.new_score_list[player_index] - result.pre_score_list[player_index] - score
            }
            else if (content_index === 3) {
                return result.new_score_list[player_index]
            }
        },
        setResultScoreArrow(player_index) {
            let result = this.queryResult(this.selected_result_id)
            let score = result.new_score_list[player_index] - result.pre_score_list[player_index]
            if (score > 0) {
                return 1
            }
            else if (score < 0) {
                return -1
            }
            else {
                return 0
            }
        },
        // condition-part
        async addCondition() {
            if (!this.lock) {
                this.$message.error('请先锁定')
                return
            }
            const selected_player_id_list = this.selected_player_id_list.filter(item => item !== '')
            const selected_match_id_list = this.selected_match_id_list.filter(item =>item !== '')
            if (selected_player_id_list.length === 0) {
                this.$message.error('球员列表为空')
                return
            }
            if (selected_match_id_list.length === 0) {
                this.$message.error('赛事列表为空')
                return
            }
            this.loading_conditions = true
            const response = await addFilterCondition(this.new_condition)
            if (response.status === 200) {
                if (response.data.success) {
                    this.conditions.push(response.data.data)
                    this.new_condition = ''
                    this.$message.success('添加成功')
                }
                else {
                    this.$message.error('添加失败')
                }
            }
            this.loading_conditions = false
        },
        changeConditions(selectedRowKeys) { this.selected_condition_id_list = selectedRowKeys },
        async deleteCondition(condition_id) {
            if (!this.lock) {
                this.$message.error('请先锁定')
                return
            }
            const response = await deleteFilterCondition(condition_id)
            if (response.status === 200) {
                if (response.data.success) {
                    let index = this.conditions.findIndex(item => item.condition_id === condition_id)
                    this.conditions.splice(index, 1);
                    index = this.selected_condition_id_list.findIndex(item => item === condition_id)
                    if(index !== -1) {
                        this.selected_condition_id_list.splice(index, 1);
                    }
                    this.$message.success('删除成功')
                }
                else {
                    this.$message.error('删除失败')
                }
            }

        },
        async getResults() {
            if (!this.lock) {
                this.$message.error('请先锁定')
                return
            }
            const selected_player_id_list = this.selected_player_id_list.filter(item => item !== '')
            const selected_match_id_list = this.selected_match_id_list.filter(item => item !== '')
            if (selected_player_id_list.length === 0) {
                this.$message.error('球员列表为空')
                return
            }
            if (selected_match_id_list.length === 0) {
                this.$message.error('赛事列表为空')
                return
            }
            if (this.selected_condition_id_list.length === 0) {
                this.$message.error('未选择筛选条件')
                return
            }
            // result-table
            this.selected_result_id = -1
            this.coordinates = []
            // result-part
            this.results = []
            this.current_result_cnt = 0
            this.collected_result_list = []
            this.loading_results = true
            const response = await getFilterResults(this.selected_condition_id_list)
            if (response.status === 200) {
                if (response.data.success) {


                    // --- 新的精确去重逻辑开始 ---
                    const resList = response.data.data;
                    const uniqueResults = [];
                    const seenScores = new Set();
                  resList.forEach(item => {
                    const scoreResult = item.score_result;

                    // 直接将整个 score_result 对象字符串化作为唯一键
                    const uniqueKey = JSON.stringify(scoreResult);

                    if (!seenScores.has(uniqueKey)) {
                      seenScores.add(uniqueKey);
                      uniqueResults.push(item);
                    }
                  });
                  // --- 新的精确去重逻辑结束 ---

                  this.results = uniqueResults; // 使用去重后的列表
                  this.current_result_cnt = Math.min(uniqueResults.length,20)
                    this.$message.success('筛选成功')
                }
                else {
                    this.$message.error('筛选失败')
                }
            }
            this.loading_results = false
            // Debug print
            // console.log(this.conditions)
            // console.log(this.selected_condition_id_list)
            // console.log(this.results)
        },
        // result-part
        async getPlayerHeadshot() {
            const response = await getPlayerHeadshotById(this.selected_player_id_list)
            if (response.status === 200) {
                if (response.data.success) {
                    this.selected_player_headshot_list = []
                    response.data.data.forEach(player_headshot => {
                        if (player_headshot === '') {
                            this.selected_player_headshot_list.push('')
                        }
                        else {
                            this.selected_player_headshot_list.push(player_headshot[0]["headshot"])
                        }
                    })
                }
            }
        },
        setResultRowColor(record, index) {
            return {
                style: {
                    backgroundColor: this.selected_result_id === record.result_id ? '#7796B1' : index % 2 === 0 ? '#D5E3EF' : '#F8FAFB',
                    color: this.selected_result_id === record.result_id ? '#F8FAFB' : '#00375B',
                    fontSize: '20px',
                    fontWeight: 'bold',
                },
            }
        },
        collectResult(result_id) {
            if (!this.lock) {
                this.$message.error('请先锁定')
                return
            }
            for (let index = 0; index < this.collected_result_list.length; ++index) {
                if (result_id === this.collected_result_list[index]['result_id']) {
                    this.collected_result_list.splice(index, 1);
                    this.$message.success('取消收藏')
                    return
                }
            }
            this.collected_result_list.push({
                'result_id': result_id,
                'coordinates': this.calculateCoordinates(result_id)
            })
            this.$message.success('已收藏')
        },
        isCollected(result_id) {
            for (let index = 0; index < this.collected_result_list.length; ++index) {
                if (result_id === this.collected_result_list[index]['result_id']) {
                    return true
                }
            }
            return false
        },
        selectResult(result_id) {
            if (!this.lock) {
                this.$message.error('请先锁定')
                return
            }
            if (this.selected_result_id === result_id) {
                this.selected_result_id = -1
                this.coordinates = []
            }
            else {
                this.selected_result_id = result_id
                this.coordinates = this.calculateCoordinates(result_id)
            }
        },
        deleteResult(result_id) {
            if (!this.lock) {
                this.$message.error('请先锁定')
                return
            }
            if (this.selected_result_id === result_id) {
                this.$message.error('该结果正在分析，不可删除')
            }
            else {
                const index = this.results.findIndex(item => item.result_id === result_id)
                this.results.splice(index, 1);
                this.$message.success('删除成功')
            }
        },
        async getMoreResults(cnt) {
            if (!this.lock) {
                this.$message.error('请先锁定')
                return
            }
            this.loading_results = true
            const response = await getNextGroupOfFilterResults(this.current_result_cnt, cnt)
            if (response.status === 200) {
                if (response.data.success) {
                    response.data.data.forEach(result => {
                        this.results.push(result)
                    })
                    this.current_result_cnt += response.data.data.length
                    this.$message.success('添加成功')
                }
                else {
                    this.$message.error('添加失败')
                }
            }
            this.loading_results = false
        },
    },
}
</script>

<style scoped lang="less">
.clickable {
    cursor: pointer;
    pointer-events: auto;
}
// top-bar
.ranking-table ::v-deep .ant-table-thead > tr > th {
    background: #00375B;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 22px;
}
.ranking-table ::v-deep .ant-pagination-item a {
    font-size: 14px;
}
.ranking-detail-table ::v-deep .ant-table-thead > tr > th {
    background: #00375B;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 20px;
}
// deduction-table
.match-select ::v-deep .ant-select-selection {
    background: #F3F2F2;
}
.player-select ::v-deep .ant-select-selection {
    background: #F3F2F2;
    border-color: #F3F2F2;
    border-radius: 0;
    color: #00375B;
    font-weight: bold;
    font-size: 18px;
    justify-items: center;
}
// condition-table
.condition-table ::v-deep(.ant-checkbox-inner) {
    border: 2px solid #00375B !important;
}

.condition-table ::v-deep(.ant-checkbox-checked .ant-checkbox-inner) {
    background-color: #00375B !important;
    border-color: #00375B !important;
}
// result-table
::v-deep {
    .no-hover-table table tbody tr:hover > td {
        background-color: transparent !important;
    }
}
</style>
